import { render, staticRenderFns } from "./mktPushButton.vue?vue&type=template&id=71151811&"
import script from "./mktPushButton.vue?vue&type=script&lang=js&"
export * from "./mktPushButton.vue?vue&type=script&lang=js&"
import style0 from "./mktPushButton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports